import { GET, POST, PUT, DELETE, gatewayURL } from "./httpAPI";

const backend = {
  register: (request) => {
    return POST("/public/register", request);
  },
  registerAppsumo: (request) => {
    return POST("/public/register/appsumo", request);
  },
  registerPitchGround: (request) => {
    return POST("/public/register/pitchground", request);
  },
  registerDealify: (request) => {
    return POST("/public/register/dealify", request);
  },
  getInvitation: (uid) => {
    return GET("/public/invitations/" + uid);
  },
  registerByInvitation: (uid, request) => {
    return POST("/public/invitations/" + uid, request);
  },

  loginWithPassword: (username, password) => {
    return POST("/auth/login", { username, password });
  },
  resetPassword: (request) => {
    return POST("/public/forgot-password/reset", request);
  },
  getResetToken: (token) => {
    return GET("/public/forgot-password/reset/" + token);
  },
  finishReset: (token, request) => {
    return POST("/public/forgot-password/reset/" + token, request);
  },
  uploadAsset: (workspaceId, file, filename) => {
    const request = new FormData();
    request.append("file", file);
    request.append("filename", filename);
    return POST("/public/media/" + workspaceId + "/assets", request, true);
  },
  getMediaAsset: (workspaceId, uid) => {
    return GET("/public/media/" + workspaceId + "/assets/" + uid);
  },
  /*
  getMediaAssets: ( workspaceId, page) => {
    return GET("/public/media/" + workspaceId + "/assets?p=" + page);
  },
  getMediaAsset: ( workspaceId, uid) => {
    return GET("/public/media/" + workspaceId + "/assets/" + uid);
  },
  deleteMediaAsset: ( workspaceId, asset) => {
    return POST("/public/media/" + workspaceId + "/assets/" + asset.uid + "/delete");
  },
  updateMediaAssetImage: ( workspaceId, asset, image) => {
    const request = new FormData();
    request.append("file", image);
    return POST("/public/media/" + workspaceId + "/assets/" + asset.uid, request, true);
  },
 
  getUnsplashPhotos: ( workspaceId, page) => {
    return GET("/public/media/" + workspaceId + "/unsplash" + (page ? "?p=" + page : ""));
  },
  searchUnsplashPhotos: ( workspaceId, query, page) => {
    return GET("/public/media/" + workspaceId + "/unsplash/search?q=" + query + "&p=" + page);
  },
  addUnsplashPhoto: ( workspaceId, photo) => {
    return POST("/public/media/" + workspaceId + "/unsplash/add", photo);
  },
   */
  changePassword: (current, next) => {
    return POST("/users/creds", { current, next });
  },
  processOrder: (orderId, orderReference) => {
    return POST("/subscription/order", { orderId, orderReference });
  },
  getOrders: () => {
    return GET("/subscription/orders");
  },
  upgradeSubscription: (plan) => {
    return POST("/subscription/change", { plan });
  },

  processCreditsOrder: (orderId, orderReference) => {
    return POST("/credits/order", { orderId, orderReference });
  },
  getAccountCredits: () => {
    return GET("/credits");
  },

  // workspace
  getWorkspaces: () => {
    return GET("/workspaces");
  },
  lookupWorkspace: (templateUid) => {
    return GET("/sdk/workspace-lookup?templateId=" + templateUid);
  },
  createWorkspace: (name) => {
    return POST("/workspaces", { name });
  },
  deleteWorkspace: (uid) => {
    return POST("/workspaces/" + uid + "/delete");
  },
  updateWorkspace: (uid, request) => {
    return POST("/workspaces/" + uid, request);
  },
  // workspace members
  getWorkspaceMembers: (uid) => {
    return GET("/workspaces/" + uid + "/users");
  },
  sendWorkspaceInvite: (workspaceId, { email, isAdmin }) => {
    return POST("/workspaces/" + workspaceId + "/users", {
      email,
      role: isAdmin ? "ADMIN" : "CONTRIBUTOR",
    });
  },
  cancelWorkspaceInvite: (workspaceId, uid) => {
    return POST(
      "/workspaces/" + workspaceId + "/invitations/" + uid + "/delete"
    );
  },
  updateWorkspaceMember: (workspaceId, uid, role) => {
    console.log("updateWorkspaceMember ", uid, role);
    return POST("/workspaces/" + workspaceId + "/users/" + uid, { role });
  },
  deleteWorkspaceMember: (workspaceId, uid) => {
    return POST("/workspaces/" + workspaceId + "/users/" + uid + "/delete");
  },
  // fonts
  getWorkspaceFonts: (uid) => {
    return GET("/workspaces/" + uid + "/fonts");
  },
  createWorkspaceFont: (workspaceId, file) => {
    const request = new FormData();
    request.append("file", file);
    return POST("/workspaces/" + workspaceId + "/fonts", request, true);
  },
  deleteWorkspaceFont: (workspaceId, uid) => {
    return POST("/workspaces/" + workspaceId + "/fonts/" + uid + "/delete");
  },
  // team
  getTeam: () => {
    return GET("/team");
  },
  sendInvite: ({ email, isAdmin }) => {
    return POST("/team", { email, role: isAdmin ? "ADMIN" : "CONTRIBUTOR" });
  },
  cancelInvite: (uid) => {
    return POST("/team/invitations/" + uid + "/delete");
  },
  deleteMember: (uid) => {
    return POST("/team/members/" + uid + "/delete");
  },
  // new
  createCampaign: (name, workspaceId) => {
    return POST("/w/" + workspaceId + "/campaigns", { name });
  },
  getCampaigns: (workspaceId) => {
    return GET("/w/" + workspaceId + "/campaigns");
  },
  getCampaign: (workspaceId, campaignId) => {
    return GET("/w/" + workspaceId + "/campaigns/" + campaignId);
  },
  deleteCampaign: (workspaceId, campaignId) => {
    return DELETE("/w/" + workspaceId + "/campaigns/" + campaignId);
  },
  updateCampaign: (workspaceId, uid, campaign) => {
    return PUT("/w/" + workspaceId + "/campaigns/" + uid, campaign);
  },
  getInterviewCampaign: (campaignId) => {
    return GET("/public/interview-campaigns/" + campaignId);
  },
  createSubmission: (campaignId, name, email) => {
    return POST("/public/interviews", { campaignId, name, email });
  },
  getUserSubmission: (submissionId) => {
    return GET("/public/interviews/" + submissionId);
  },
  updateUserSubmission: (submissionId, submission) => {
    return PUT("/public/interviews/" + submissionId, submission);
  },
  getSubmissions: (workspaceId, campaignId) => {
    return GET(
      "/w/" + workspaceId + "/campaigns/" + campaignId + "/submissions"
    );
  },
  getSubmission: (workspaceId, campaignId, submissionId) => {
    return GET(
      "/w/" +
        workspaceId +
        "/campaigns/" +
        campaignId +
        "/submissions/" +
        submissionId
    );
  },
  deleteSubmission: (workspaceId, campaignId, submissionId) => {
    return DELETE(
      "/w/" +
        workspaceId +
        "/campaigns/" +
        campaignId +
        "/submissions/" +
        submissionId
    );
  },
  saveSubmissionStatus: (workspaceId, campaignId, submissionId, status) => {
    return POST(
      "/w/" +
        workspaceId +
        "/campaigns/" +
        campaignId +
        "/submissions/" +
        submissionId +
        "/status",
      { status }
    );
  },
  /** promptleo new */
  createPrompt: (name, workspaceId) => {
    return POST("/w/" + workspaceId + "/prompts", { name });
  },
  getPrompts: (workspaceId) => {
    return GET("/w/" + workspaceId + "/prompts");
  },
  getPrompt: (workspaceId, id) => {
    return GET("/w/" + workspaceId + "/prompts/" + id);
  },
  deletePrompt: (workspaceId, id) => {
    return DELETE("/w/" + workspaceId + "/prompts/" + id);
  },
  updatePrompt: (workspaceId, uid, prompt) => {
    return PUT("/w/" + workspaceId + "/prompts/" + uid, prompt);
  },
  getPromptVersions: (workspaceId, id) => {
    return GET("/w/" + workspaceId + "/prompts/" + id + "/versions");
  },
  getPromptVersion: (workspaceId, promptId, versionId) => {
    return GET(
      "/w/" + workspaceId + "/prompts/" + promptId + "/versions/" + versionId
    );
  },
  createPromptVersion: (version, workspaceId, promptId) => {
    return POST(
      "/w/" + workspaceId + "/prompts/" + promptId + "/versions",
      version
    );
  },
  updatePromptVersion: (workspaceId, promptUid, version) => {
    return PUT(
      "/w/" +
        workspaceId +
        "/prompts/" +
        promptUid +
        "/versions/" +
        version.uid,
      version
    );
  },
  deletePromptVersion: (workspaceId, promptUid, versionUid) => {
    return DELETE(
      "/w/" + workspaceId + "/prompts/" + promptUid + "/versions/" + versionUid
    );
  },

  getApprovedPrompts: (workspaceId, keyword) => {
    return GET(
      "/w/" +
        workspaceId +
        "/approved-prompts" +
        (keyword ? "?keyword=" + keyword : "")
    );
  },
  /* api keys */
  createApiKey: (apiKey, workspaceId) => {
    return POST("/w/" + workspaceId + "/keys", apiKey);
  },
  getApiKeys: (workspaceId) => {
    return GET("/w/" + workspaceId + "/keys");
  },
  getApiKey: (workspaceId, id) => {
    return GET("/w/" + workspaceId + "/keys/" + id);
  },
  deleteApiKey: (workspaceId, id) => {
    return DELETE("/w/" + workspaceId + "/keys/" + id);
  },
  updateApiKey: (workspaceId, uid, apiKey) => {
    return PUT("/w/" + workspaceId + "/keys/" + uid, apiKey);
  },
  /* forms */
  createForm: (form, workspaceId) => {
    return POST("/w/" + workspaceId + "/forms", form);
  },
  getForms: (workspaceId) => {
    return GET("/w/" + workspaceId + "/forms");
  },
  getForm: (workspaceId, id) => {
    return GET("/w/" + workspaceId + "/forms/" + id);
  },
  deleteForm: (workspaceId, id) => {
    return DELETE("/w/" + workspaceId + "/forms/" + id);
  },
  updateForm: (workspaceId, uid, form) => {
    return PUT("/w/" + workspaceId + "/forms/" + uid, form);
  },
  getFormSubmissions: (workspaceId, id) => {
    return GET("/w/" + workspaceId + "/forms/" + id + "/submissions");
  },
  /** shared forms */
  getSharedForm: (workspaceId, id) => {
    return GET("/public/" + workspaceId + "/shared-forms/" + id);
  },
  getSharedSubmissionForm: (workspaceId, id) => {
    return GET("/public/" + workspaceId + "/shared-form-result/forms/" + id);
  },
  getSharedPromptVersion: (workspaceId, promptId, versionId) => {
    return GET(
      "/public/" +
        workspaceId +
        "/shared-prompts/" +
        promptId +
        "/versions/" +
        versionId
    );
  },
  getSharedFormSubmission: (workspaceId, id, submissionId) => {
    return GET(
      "/public/" +
        workspaceId +
        "/shared-form-result/submissions/" +
        submissionId
    );
  },
  /* endpoints */
  createEndpoint: (endpoint, workspaceId) => {
    return POST("/w/" + workspaceId + "/endpoints", endpoint);
  },
  getEndpoints: (workspaceId) => {
    return GET("/w/" + workspaceId + "/endpoints");
  },
  getEndpoint: (workspaceId, id) => {
    return GET("/w/" + workspaceId + "/endpoints/" + id);
  },
  deleteEndpoint: (workspaceId, id) => {
    return DELETE("/w/" + workspaceId + "/endpoints/" + id);
  },
  updateEndpoint: (workspaceId, uid, endpoint) => {
    return PUT("/w/" + workspaceId + "/endpoints/" + uid, endpoint);
  },
  getEndpointRequests: (workspaceId, id) => {
    return GET("/w/" + workspaceId + "/endpoints/" + id + "/requests");
  },
  execEndpoint: (workspaceId, uid, name, request) => {
    return PUT("/customer/" + workspaceId + "/endpoints/" + name, request);
  },
  /* flows */
  createFlow: (flow, workspaceId) => {
    return POST("/w/" + workspaceId + "/flows", flow);
  },
  getFlows: (workspaceId) => {
    return GET("/w/" + workspaceId + "/flows");
  },
  getFlow: (workspaceId, id) => {
    return GET("/w/" + workspaceId + "/flows/" + id);
  },
  deleteFlow: (workspaceId, id) => {
    return DELETE("/w/" + workspaceId + "/flows/" + id);
  },
  updateFlow: (workspaceId, uid, flow) => {
    return PUT("/w/" + workspaceId + "/flows/" + uid, flow);
  },
  /* models */
  getModel: (workspaceId, modelId) => {
    return GET("/w/" + workspaceId + "/models/" + modelId);
  },
  saveModel: (workspaceId, modelId, request) => {
    return POST("/w/" + workspaceId + "/models/" + modelId, request);
  },
  /* chats */
  getChats: (workspaceId, folderId, keyword) => {
    return GET(
      "/w/" +
        workspaceId +
        "/chats" +
        (folderId ? "?folder_id=" + folderId : "") +
        (keyword ? (folderId ? "&" : "?") + "keyword=" + keyword : "")
    );
  },
  getChat: (workspaceId, chatId) => {
    return GET("/w/" + workspaceId + "/chats/" + chatId);
  },
  createChat: (workspaceId, request) => {
    return POST("/w/" + workspaceId + "/chats", request);
  },
  cloneChat: (chatUid) => {
    return POST("/chats-clone", { chatUid });
  },
  updateChat: (workspaceId, chatId, request) => {
    return PUT("/w/" + workspaceId + "/chats/" + chatId, request);
  },
  postChatMessage: (workspaceId, chatId, message) => {
    return POST("/w/" + workspaceId + "/chats/" + chatId, { content: message });
  },
  saveReply: (workspaceId, chatId, reply) => {
    return POST("/w/" + workspaceId + "/chats/" + chatId + "/reply", reply);
  },
  deleteChat: (workspaceId, id) => {
    return DELETE("/w/" + workspaceId + "/chats/" + id);
  },
  deleteChatMessage: (workspaceId, chatId, messageId) => {
    return DELETE(
      "/w/" + workspaceId + "/chats/" + chatId + "/messages/" + messageId
    );
  },
  updateChatMessage: (workspaceId, chatId, messageId, content) => {
    return PUT(
      "/w/" + workspaceId + "/chats/" + chatId + "/messages/" + messageId,
      { content }
    );
  },
  uploadChatFile: (workspaceId, chatId, file) => {
    const request = new FormData();
    request.append("file", file);
    return POST(
      "/w/" + workspaceId + "/chats/" + chatId + "/upload",
      request,
      true
    );
  },
  lookupWorkspaceBySubdomain: (subdomainOrId) => {
    return GET("/public/workspace-lookup?subdomain=" + subdomainOrId);
  },
  /**** HUB  *****/
  getHubJobs: () => {
    return GET("/jobs");
  },
  getHubJob: (id) => {
    return GET("/jobs/" + id);
  },
  getHubJobsByModel: (model) => {
    return GET("/jobs-by-model?model=" + encodeURIComponent(model));
  },
  /***** CHATBOTS *****/
  getChatbotList: () => {
    return GET("/chatbots");
  },
  getChatbot: (uid) => {
    return GET("/chatbots/" + uid);
  },
  createChatbot: (request) => {
    return POST("/chatbots", request);
  },
  updateChatbot: (data) => {
    return PUT("/chatbots/" + data.uid, data);
  },
  deleteChatbot: (uid) => {
    return DELETE("/chatbots/" + uid);
  },
  indexChatbot: (data) => {
    return POST("/chatbots/" + data.uid + "/index", {});
  },
  getChatMessages: (chatbotUid, chatUid) => {
    return GET("/chatbots/" + chatbotUid + "/chats/" + chatUid + "/messages");
  },
  getKbpages: (chatbotUid) => {
    return GET("/chatbots/" + chatbotUid + "/kbpages");
  },
  /**** Chatbot Widbet *****/
  getWidgetChatbot: (uid, clientId) => {
    return GET("/public/chatbots/" + uid + "?cid=" + clientId);
  },
  createWidgetChat: (chatbotId, request) => {
    return POST("/public/chatbots/" + chatbotId + "/chats", request);
  },
  /***** MCP SERVERS  ******/
  getPublicMcpServers: () => {
    return GET("/public/mcp/servers");
  },
  /* vendor keys */
  createVendorKey: (apiKey, workspaceId) => {
    return POST("/w/" + workspaceId + "/vendor-keys", apiKey);
  },
  getVendorKeys: (workspaceId) => {
    return GET("/w/" + workspaceId + "/vendor-keys");
  },
  getVendorKey: (workspaceId, id) => {
    return GET("/w/" + workspaceId + "/vendor-keys/" + id);
  },
  deleteVendorKey: (workspaceId, id) => {
    return DELETE("/w/" + workspaceId + "/vendor-keys/" + id);
  },
  updateVendorKey: (workspaceId, uid, apiKey) => {
    return PUT("/w/" + workspaceId + "/vendor-keys/" + uid, apiKey);
  },
  /* integrations */
  getIntegrations: (workspaceId) => {
    return GET("/w/" + workspaceId + "/integrations");
  },
  createIntegration: (workspaceId, request) => {
    return POST("/w/" + workspaceId + "/integrations", request);
  },
  deleteIntegration: (workspaceId, uid) => {
    return DELETE("/w/" + workspaceId + "/integrations/" + uid);
  },
  testIntegration: (workspaceId, uid) => {
    return POST("/w/" + workspaceId + "/integrations/" + uid + "/test", {});
  },
  /* kbase integrations */
  getKBaseIntegrationConfig: (workspaceId, kbaseId) => {
    return GET("/w/" + workspaceId + "/kbases/" + kbaseId + "/integration");
  },
  configureKBaseIntegration: (workspaceId, kbaseId, config) => {
    return POST(
      "/w/" + workspaceId + "/kbases/" + kbaseId + "/integration/configure",
      config
    );
  },
  updateKBaseIntegration: (workspaceId, kbaseId, config) => {
    return PUT(
      "/w/" + workspaceId + "/kbases/" + kbaseId + "/integration/update",
      config
    );
  },
  removeKBaseIntegration: (workspaceId, kbaseId) => {
    return DELETE("/w/" + workspaceId + "/kbases/" + kbaseId + "/integration");
  },
  triggerKBaseSync: (workspaceId, kbaseId) => {
    return POST(
      "/w/" + workspaceId + "/kbases/" + kbaseId + "/integration/sync",
      {}
    );
  },
  getKBaseSyncStatus: (workspaceId, kbaseId) => {
    return GET(
      "/w/" + workspaceId + "/kbases/" + kbaseId + "/integration/sync-status"
    );
  },
  getKBaseSyncHistory: (workspaceId, kbaseId) => {
    return GET(
      "/w/" + workspaceId + "/kbases/" + kbaseId + "/integration/sync-history"
    );
  },
  /* tools */
  createToolPlugin: (workspaceId, data) => {
    return POST("/w/" + workspaceId + "/tool-plugins", data);
  },
  getToolPlugins: (workspaceId) => {
    return GET("/w/" + workspaceId + "/tool-plugins");
  },
  getToolPlugin: (workspaceId, id) => {
    return GET("/w/" + workspaceId + "/tool-plugins/" + id);
  },
  deleteToolPlugin: (workspaceId, id) => {
    return DELETE("/w/" + workspaceId + "/tool-plugins/" + id);
  },
  updateToolPlugin: (workspaceId, uid, toolPlugin) => {
    return PUT("/w/" + workspaceId + "/tool-plugins/" + uid, toolPlugin);
  },
  validateMcpServer: (mcpServerUrl, authType, authToken) => {
    return POST("/mcp-server-validator", { mcpServerUrl, authType, authToken });
  },
  getToolPluginSettings: (workspaceId) => {
    return GET("/w/" + workspaceId + "/tool-plugin-settings");
  },
  saveToolPluginSettings: (workspaceId, data) => {
    return POST("/w/" + workspaceId + "/tool-plugin-settings", data);
  },
  /* knowledge bases */
  createKBase: (workspaceId, name) => {
    return POST("/w/" + workspaceId + "/kbases", { name });
  },
  getKBases: (workspaceId) => {
    return GET("/w/" + workspaceId + "/kbases");
  },
  getKBase: (workspaceId, kbaseId) => {
    return GET("/w/" + workspaceId + "/kbases/" + kbaseId);
  },
  deleteKBase: (workspaceId, kbaseId) => {
    return DELETE("/w/" + workspaceId + "/kbases/" + kbaseId);
  },
  updateKBase: (workspaceId, kbaseId, data) => {
    return PUT("/w/" + workspaceId + "/kbases/" + kbaseId, data);
  },
  /* knowledge base assets */
  getKBAssets: (workspaceId, kbaseId, folderId, keyword, assetTypes) => {
    const params = new URLSearchParams();
    if (folderId) params.append("folder_id", folderId);
    if (keyword) params.append("keyword", keyword);
    if (assetTypes && assetTypes.length > 0) {
      assetTypes.forEach((type) => params.append("asset_types", type));
    }
    const queryString = params.toString();
    return GET(
      "/w/" +
        workspaceId +
        "/kbases/" +
        kbaseId +
        "/assets" +
        (queryString ? "?" + queryString : "")
    );
  },
  getKBAsset: (workspaceId, kbaseId, assetId) => {
    return GET(
      "/w/" + workspaceId + "/kbases/" + kbaseId + "/assets/" + assetId
    );
  },
  createKBAsset: (workspaceId, kbaseId, data) => {
    return POST("/w/" + workspaceId + "/kbases/" + kbaseId + "/assets", data);
  },
  updateKBAsset: (workspaceId, kbaseId, assetId, data) => {
    return PUT(
      "/w/" + workspaceId + "/kbases/" + kbaseId + "/assets/" + assetId,
      data
    );
  },
  deleteKBAsset: (workspaceId, kbaseId, assetId) => {
    return DELETE(
      "/w/" + workspaceId + "/kbases/" + kbaseId + "/assets/" + assetId
    );
  },
  uploadKBAssetFile: (workspaceId, kbaseId, file, folderId) => {
    const request = new FormData();
    request.append("file", file);
    const url =
      "/w/" +
      workspaceId +
      "/kbases/" +
      kbaseId +
      "/assets/upload" +
      (folderId ? "?folder_id=" + folderId : "");
    return POST(url, request, true);
  },
  downloadKBAssetFile: (workspaceId, kbaseId, assetId) => {
    const url =
      "/w/" +
      workspaceId +
      "/kbases/" +
      kbaseId +
      "/assets/" +
      assetId +
      "/download";
    // Import backendURL and authStore to construct the full URL with auth
    const { backendURL } = require("./httpAPI");
    const authStore = require("../components/auth/AuthStore").default;
    const apiKey = authStore.getToken();

    if (apiKey) {
      // For downloads with auth, we need to use fetch and blob
      fetch(backendURL + url, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + apiKey,
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          // Extract filename from Content-Disposition header
          const contentDisposition = response.headers.get(
            "Content-Disposition"
          );
          let filename = "download";
          if (contentDisposition) {
            const filenameMatch =
              contentDisposition.match(/filename="?([^"]+)"?/);
            if (filenameMatch && filenameMatch[1]) {
              filename = filenameMatch[1];
            }
          }
          return response.blob().then((blob) => ({ blob, filename }));
        })
        .then(({ blob, filename }) => {
          console.log(
            "Downloaded blob size:",
            blob.size,
            "filename:",
            filename
          );
          const blobUrl = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = blobUrl;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(blobUrl);
        })
        .catch((err) => {
          console.error("Download failed:", err);
        });
    } else {
      // Fallback for unauthenticated download (shouldn't happen)
      const link = document.createElement("a");
      link.href = backendURL + url;
      link.setAttribute("download", "");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  },
  downloadKBAsset: (workspaceId, kbaseId, assetId) => {
    return (
      "/api/w/" +
      workspaceId +
      "/kbases/" +
      kbaseId +
      "/assets/" +
      assetId +
      "/download"
    );
  },
  /* assistants */
  createAssistant: (workspaceId, assistant) => {
    return POST("/w/" + workspaceId + "/assistants", assistant);
  },
  getAssistants: (workspaceId) => {
    return GET("/w/" + workspaceId + "/assistants");
  },
  getAssistant: (workspaceId, id) => {
    return GET("/w/" + workspaceId + "/assistants/" + id);
  },
  deleteAssistant: (workspaceId, id) => {
    return DELETE("/w/" + workspaceId + "/assistants/" + id);
  },
  updateAssistant: (workspaceId, uid, assistant) => {
    return PUT("/w/" + workspaceId + "/assistants/" + uid, assistant);
  },
  /* gateways */
  createGateway: (workspaceId, gateway) => {
    return POST("/w/" + workspaceId + "/gateways", gateway);
  },
  getGateways: (workspaceId) => {
    return GET("/w/" + workspaceId + "/gateways");
  },
  getGateway: (workspaceId, id) => {
    return GET("/w/" + workspaceId + "/gateways/" + id);
  },
  deleteGateway: (workspaceId, id) => {
    return DELETE("/w/" + workspaceId + "/gateways/" + id);
  },
  updateGateway: (workspaceId, uid, gateway) => {
    return PUT("/w/" + workspaceId + "/gateways/" + uid, gateway);
  },
  /* gateway analytics (calls gateway-1 service directly) */
  getGatewayLogs: (gatewayUid, page, size, modelId, startDate, endDate) => {
    const params = new URLSearchParams();
    params.append("gatewayUid", gatewayUid);
    params.append("page", page);
    params.append("size", size);
    if (modelId) params.append("modelId", modelId);
    if (startDate) params.append("startDate", startDate.toISOString());
    if (endDate) params.append("endDate", endDate.toISOString());
    return GET("/v1/analytics/logs?" + params.toString(), gatewayURL);
  },
  getGatewayStats: (gatewayUid, modelId, startDate, endDate) => {
    const params = new URLSearchParams();
    params.append("gatewayUid", gatewayUid);
    if (modelId) params.append("modelId", modelId);
    if (startDate) params.append("startDate", startDate.toISOString());
    if (endDate) params.append("endDate", endDate.toISOString());
    return GET("/v1/analytics/stats?" + params.toString(), gatewayURL);
  },
  getGatewayTimeSeries: (gatewayUid, modelId, startDate, endDate) => {
    const params = new URLSearchParams();
    params.append("gatewayUid", gatewayUid);
    if (modelId) params.append("modelId", modelId);
    if (startDate) params.append("startDate", startDate.toISOString());
    if (endDate) params.append("endDate", endDate.toISOString());
    return GET("/v1/analytics/timeseries?" + params.toString(), gatewayURL);
  },
  getGatewayLogDetail: (logUid) => {
    return GET("/v1/analytics/logs/" + logUid, gatewayURL);
  },
  /* builder projects */
  getBuilderProjects: (workspaceId) => {
    return GET("/builder-backend/rest/w/" + workspaceId + "/projects", "");
  },
  getBuilderProject: (workspaceId, projectUid) => {
    return GET("/builder-backend/rest/w/" + workspaceId + "/projects/" + projectUid, "");
  },
  createBuilderProject: (workspaceId, data) => {
    return POST("/builder-backend/rest/w/" + workspaceId + "/projects", data, false, "");
  },
  deleteBuilderProject: (workspaceId, projectUid) => {
    return DELETE("/builder-backend/rest/w/" + workspaceId + "/projects/" + projectUid, "");
  },
  updateBuilderProject: (workspaceId, projectUid, data) => {
    return PUT("/builder-backend/rest/w/" + workspaceId + "/projects/" + projectUid, data, false, "");
  },
  checkCustomDomainDns: (workspaceId, projectUid) => {
    return POST("/builder-backend/rest/w/" + workspaceId + "/projects/" + projectUid + "/custom-domain/check", {}, false, "");
  },
  removeCustomDomain: (workspaceId, projectUid) => {
    return DELETE("/builder-backend/rest/w/" + workspaceId + "/projects/" + projectUid + "/custom-domain", "");
  },
  /* builder chats */
  getBuilderChat: (workspaceId, chatUid) => {
    return GET("/builder-backend/rest/w/" + workspaceId + "/chats/" + chatUid, "");
  },
  /* builder agent sessions */
  getActiveAgentSession: (workspaceId, chatUid) => {
    return GET("/builder-backend/rest/w/" + workspaceId + "/chats/" + chatUid + "/agent-session", "");
  },
  /* builder project files */
  getProjectFileTree: (workspaceId, projectUid, path = null) => {
    const url = "/builder-backend/rest/w/" + workspaceId + "/projects/" + projectUid + "/files/tree" +
      (path ? "?path=" + encodeURIComponent(path) : "");
    return GET(url, "");
  },
  getProjectFileContent: (workspaceId, projectUid, path) => {
    const url = "/builder-backend/rest/w/" + workspaceId + "/projects/" + projectUid + "/files/content" +
      "?path=" + encodeURIComponent(path);
    return GET(url, "");
  },
  saveProjectFileContent: (workspaceId, projectUid, path, content) => {
    const url = "/builder-backend/rest/w/" + workspaceId + "/projects/" + projectUid + "/files/content" +
      "?path=" + encodeURIComponent(path);
    // Need to send as text/plain, not JSON
    const authStore = require("../components/auth/AuthStore").default;
    const apiKey = authStore.getToken();

    return fetch(url, {
      method: "PUT",
      headers: {
        "Authorization": "Bearer " + apiKey,
        "Content-Type": "text/plain",
      },
      body: content,
    }).then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    });
  },
  searchProjectFiles: (workspaceId, projectUid, query) => {
    const url = "/builder-backend/rest/w/" + workspaceId + "/projects/" + projectUid + "/files/search" +
      "?q=" + encodeURIComponent(query);
    return GET(url, "");
  },
  getProjectFileDownloadUrl: (workspaceId, projectUid, path) => {
    return "/builder-backend/rest/w/" + workspaceId + "/projects/" + projectUid + "/files/download" +
      "?path=" + encodeURIComponent(path);
  },
  /* builder project events */
  getProjectEvents: (workspaceId, projectUid) => {
    const url = "/builder-backend/rest/w/" + workspaceId + "/projects/" + projectUid + "/project-events";
    return GET(url, "");
  },
  /* builder templates */
  getTemplates: () => {
    return GET("/builder-backend/rest/templates", "");
  },
  getTemplate: (templateUid) => {
    return GET("/builder-backend/rest/templates/" + templateUid, "");
  },
  updateTemplate: (templateUid, data) => {
    return PUT("/builder-backend/rest/templates/" + templateUid, data, false, "");
  },
  deleteTemplate: (templateUid) => {
    return DELETE("/builder-backend/rest/templates/" + templateUid, "");
  },
  exportAsTemplate: (workspaceId, projectUid) => {
    return POST("/builder-backend/rest/w/" + workspaceId + "/projects/" + projectUid + "/clone?asTemplate=true", {}, false, "");
  },
  instantiateTemplate: (workspaceId, templateUid) => {
    return POST("/builder-backend/rest/w/" + workspaceId + "/templates/" + templateUid + "/instantiate", {}, false, "");
  },
};

export default backend;
